module.exports = __webpack_public_path__ + "img/NMR.4cdb8e3d.svg";